import {redirectStripeAccountManagement, redirectPaymentHealth_mobility, redirectPaymentMultimedia_insurance} from "../api/InsuranceApi";
import {toastr} from "react-redux-toastr";
import { appLoading, appSuccess, appError } from "../redux/actions/appActions";
import LocalStorageService from './LocalStorageService';
import { getMe } from '../api/authApi';

export const isAuthenticated = () => {
  const enrichedUser = LocalStorageService.getUser();
  
  if (enrichedUser && enrichedUser.email && enrichedUser.roles && enrichedUser.roles[0] !== "none") {
    return {
      data: enrichedUser,
      token: true
    };
  }
  
  return false;
}

export const checkAuthenticationStatus = async () => {
  try {
    const response = await getMe();
    if (response.data) {
      return {
        data: response.data,
        token: true
      };
    }
    return false;
  } catch (error) {
    return false;
  }
}

export const isAdminUser = (user) => {
  if (user.roles) {
      return user.roles[0] === 'ROLE_ADMIN';
  } else {
     return false;
  }
}

export const validateAccessUser = (view, rol) => {
  return view.roles.some(item => item === rol);
}

// ... Garde toutes tes autres fonctions inchangées
export const redirectPaymentPageMobility = (data) => {
  redirectPaymentHealth_mobility(data)
    .then((response) => {
      const { data } = response;
      window.location.href = data;
    })
    .catch((error) => {
      if(error && error.response && error.response.data){
        toastr.error('ERROR', error.response.data.message);
        console.log('ERROR: ', error.response.data.message);
      } else {
        toastr.error('ERROR', error.response.data.message);
        console.log('ERROR: ','error connected to server');
      }
    })
}

export const redirectPaymentPageMultimedia = (data, dispatch) => {
  dispatch(appLoading());

  redirectPaymentMultimedia_insurance(data)
    .then((response) => {
      const { data } = response;
      dispatch(appSuccess());
      window.location.href = data;
    })
    .catch((error) => {
      dispatch(appError());
      if(error && error.response && error.response.data){
        toastr.error('ERROR', error.response.data.message);
        console.log('ERROR: ', error.response.data.message);
      } else {
        toastr.error('ERROR', error.response.data.message);
        console.log('ERROR: ','error connected to server');
      }
    })
}


export const redirectAccountStripeManagement = (data, dispatch) => {
  dispatch(appLoading());

  redirectStripeAccountManagement(data)
    .then((response) => {
      dispatch(appSuccess());
      const { data } = response;
      window.location.href = data;
    })
    .catch((error) => {
      dispatch(appError());
      if(error && error.response && error.response.data){
        toastr.error('ERROR', error.response.data.message);
        console.log('ERROR: ', error.response.data.message);
      } else {
        toastr.error('ERROR', error.response.data.message);
        console.log('ERROR: ','error connected to server');
      }
    })
}